import wariChoraImg from "@/assets/regions/wari-chora.jpg";
import sijuCaveImg from "@/assets/regions/siju-cave.jpg";
import nokrekImg from "@/assets/regions/nokrek.jpg";
import pelgaWaterFallsImg from "@/assets/regions/pelga-water-falls.jpg";
import balpakramImg from "@/assets/regions/balpakram.jpg";
import trekkingImg from "@/assets/experiences/trekking.png";
import jungleExpImg from "@/assets/experiences/jungle.png";
import fishingExpImg from "@/assets/experiences/fishing.png";
import terraRoomImg from "@/assets/rooms/terra.png";
import cliffstoneRoomImg from "@/assets/rooms/cliffstone.png";
import horizonRoomImg from "@/assets/rooms/horizon.jpg";
import theOrchidRoomImg from "@/assets/rooms/the-orchid.png";
import theVandaGrandRoomImg from "@/assets/rooms/the-vanda-grand.png";
import banquet1Img from "@/assets/banquet/banquet-1.png";
import banquet2Img from "@/assets/banquet/banquet-2.png";
import conference1Img from "@/assets/banquet/conference-1.png";
import conference2Img from "@/assets/banquet/conference-2.jpeg";
import gymImg from "@/assets/amenities/gym.png";
import restaurantImg from "@/assets/amenities/restaurant.png";
import poolImg from "@/assets/amenities/pool.png";
import spaImg from "@/assets/amenities/spa.png";
import atriumReceptionImg from "@/assets/hotel/atrium-reception.png";
import doubleHeightLoungeImg from "@/assets/hotel/double-height-lounge.png";
import theVandaBuildingImg from "@/assets/hotel/the-vanda.png";
import logoSymbol from "@/assets/logo/TheVanda_Logo_Symbol_BurntOrange.svg";
import vandaHeroImg from "@/assets/hotel/tura-bg.jpg";
import orchidPatternImg from "@/assets/hotel/TheVanda_Pattern_Orchid.jpg";
import footerVandaImg from "@/assets/hotel/footer-vanda.png";
import logoLockupGold from "@/assets/logo/TheVanda_Logo_Lockup_Gold.svg";

export const media = {
  hero: "https://images.unsplash.com/photo-1619548372323-6c852bc2d59a?crop=entropy&cs=srgb&fm=jpg&q=85",
  hotelA: "https://images.unsplash.com/photo-1566073771259-6a8506099945?crop=entropy&cs=srgb&fm=jpg&q=85",
  hotelB: "https://images.unsplash.com/photo-1445019980597-93fa8acb246c?crop=entropy&cs=srgb&fm=jpg&q=85",
  intro: "https://images.unsplash.com/photo-1618773928121-c32242e63f39?crop=entropy&cs=srgb&fm=jpg&q=85",
  room1: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?crop=entropy&cs=srgb&fm=jpg&q=85",
  room2: "https://images.unsplash.com/photo-1590490360182-c33d57733427?crop=entropy&cs=srgb&fm=jpg&q=85",
  room3: "https://images.unsplash.com/photo-1591088398332-8a7791972843?crop=entropy&cs=srgb&fm=jpg&q=85",
  room4: "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?crop=entropy&cs=srgb&fm=jpg&q=85",
  room5: "https://images.unsplash.com/photo-1582719508461-905c673771fd?crop=entropy&cs=srgb&fm=jpg&q=85",
  roomsBanner: "https://images.unsplash.com/photo-1611892440504-42a792e24d32?crop=entropy&cs=srgb&fm=jpg&q=85",
  dining: "https://images.unsplash.com/photo-1552566626-52f8b828add9?crop=entropy&cs=srgb&fm=jpg&q=85",
  pool: "https://images.unsplash.com/photo-1544551763-46a013bb70d5?crop=entropy&cs=srgb&fm=jpg&q=85",
  restaurantInterior: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?crop=entropy&cs=srgb&fm=jpg&q=85",
  banquetHall: "https://images.unsplash.com/photo-1519741497674-611481863552?crop=entropy&cs=srgb&fm=jpg&q=85",
  conferenceHall: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?crop=entropy&cs=srgb&fm=jpg&q=85",
  spa: "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?crop=entropy&cs=srgb&fm=jpg&q=85",
  gym: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?crop=entropy&cs=srgb&fm=jpg&q=85",
  hike: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?crop=entropy&cs=srgb&fm=jpg&q=85",
  fishing: "https://images.unsplash.com/photo-1516132006923-6cf348e5dee2?crop=entropy&cs=srgb&fm=jpg&q=85",
  jungle: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?crop=entropy&cs=srgb&fm=jpg&q=85",
  banquet: "https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export {
  wariChoraImg, sijuCaveImg, nokrekImg, pelgaWaterFallsImg, balpakramImg,
  trekkingImg, jungleExpImg, fishingExpImg,
  terraRoomImg, cliffstoneRoomImg, horizonRoomImg, theOrchidRoomImg, theVandaGrandRoomImg,
  banquet1Img, banquet2Img, conference1Img, conference2Img,
  gymImg, restaurantImg, poolImg, spaImg,
  atriumReceptionImg, doubleHeightLoungeImg, theVandaBuildingImg,
  logoSymbol, vandaHeroImg, orchidPatternImg, footerVandaImg, logoLockupGold,
};

export const rooms = [
  { name: "Earth", tag: "Earth", desc: "Grounded comfort, styled with warmth and simplicity.", longDesc: "A compact, no-frill room finished in earthy textures and light tones, complemented by traditional art — an easy base for the traveller on the move.", img: terraRoomImg },
  { name: "Rock", tag: "Rock", desc: "Sturdy, dependable comfort for a restful stay.", longDesc: "A panelled, stone-textured wall brings the character of the hills indoors, paired with traditional art for a room built around calm.", img: cliffstoneRoomImg },
  { name: "Air", tag: "Air", desc: "Light, airy rooms designed to help you unwind.", longDesc: "Spacious and green-facing, with openable windows and a generous use of wood — a setting for the traveller who values space and stillness alike.", img: horizonRoomImg },
  { name: "Junior Suite", tag: "Junior Suite", desc: "A little extra space for a more relaxed stay.", longDesc: "A separate living area joins the bedroom, giving room to unwind beyond the bed itself.", img: theOrchidRoomImg },
  { name: "Presidential Suite", tag: "Presidential Suite", desc: "Our finest room, for a stay to remember.", longDesc: "The most generous of The Vanda's suites, with a private living area and refined interiors throughout.", img: theVandaGrandRoomImg },
];

export const roomAmenities = [
  { label: "King Bed with Premium Linens", icon: "bed" },
  { label: "High Speed Wi-Fi", icon: "wifi" },
  { label: "Smart Television", icon: "tv" },
  { label: "Daily Housekeeping", icon: "housekeeping" },
  { label: "Plush Bathrobes & Slippers", icon: "robe" },
  { label: "Tea & Coffee Station", icon: "coffee" },
  { label: "In-room Safe", icon: "safe" },
  { label: "Writing Desk", icon: "desk" },
  { label: "Climate Control", icon: "climate" },
  { label: "Hairdryer", icon: "hairdryer" },
  { label: "Minibar", icon: "minibar" },
  { label: "Walk-in Shower", icon: "shower" },
];

export const suiteAmenities = [
  { label: "Private Balcony", icon: "balcony" },
  { label: "Living + Sleeping Area", icon: "layout" },
];

export const banquetImages = [
  { src: banquet1Img, alt: "Banquet hall setup at The Vanda" },
  { src: conference1Img, alt: "Conference hall at The Vanda" },
  { src: banquet2Img, alt: "Banquet hall seating at The Vanda" },
  { src: conference2Img, alt: "Conference table at The Vanda" },
];

export const destinations = [
  { name: "Wari Chora", tag: "River gorge", img: wariChoraImg },
  { name: "Siju Cave", tag: "Ancient caves", img: sijuCaveImg },
  { name: "Nokrek", tag: "Biosphere reserve", img: nokrekImg },
  { name: "Pelga Water Falls", tag: "Cascading falls", img: pelgaWaterFallsImg },
  { name: "Balpakram National Park", tag: "Wildlife", img: balpakramImg },
];

export const amenityGrid = [
  { name: "Swimming Pool", desc: "A quiet outdoor pool to slow down between adventures.", img: poolImg },
  { name: "Wi-Fi and Internet", desc: "Complimentary high-speed Wi-Fi across every corner of the property.", img: media.hotelA },
  { name: "Fitness", desc: "A fully-equipped fitness studio open around the clock.", img: gymImg },
  { name: "The Orchid Terrace", desc: "Thoughtfully prepared meals served through the day.", img: restaurantImg },
];

export const services = [
  { title: "Swimming Pool", desc: "A quiet plunge above the town — open to the sky, the perfect place to slow down between a day out and dinner.", img: poolImg, icon: "wave" },
  { title: "The Orchid Spa Retreat", desc: "Treatments unfold slowly here — warm stone, quiet hands, and rituals drawn from the hills of Meghalaya themselves.", img: spaImg, icon: "lotus" },
  { title: "The Summit Fitness Studio", desc: "Floor-to-ceiling light and modern equipment meet at first light — a space built for movement, not just machines.", img: gymImg, icon: "dumbbell" },
];

export const experiences = [
  { title: "Trek to Tura Peak", desc: "A full-day trek to Tura Peak, overlooking the beautiful town of Tura.", img: trekkingImg },
  { title: "A Day in the Jungle, by the River", desc: "Spend a day out in the jungle, by the riverside, cooking on wood — where the river water is your deck, and the outdoors is your restaurant. Experience how life feels, away from concrete.", img: jungleExpImg },
  { title: "Experience Fishing", desc: "Something modern city life has left behind — fishing was once one of the main means of living in the early days of civilisation. Experience it for yourself.", img: fishingExpImg },
];

export const nav = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "The Orchid Terrace", to: "/dining" },
  { label: "Rooms & Suites", to: "/rooms" },
  { label: "Experiences", to: "/experiences" },
  { label: "Contact Us", to: "/#footer" },
];

export const IconGlyph = ({ name }) => {
  const stroke = { fill: "none", stroke: "currentColor", strokeWidth: 1.4, strokeLinecap: "round", strokeLinejoin: "round" };
  if (name === "plane") return (
    <svg viewBox="0 0 32 32" width="30" height="30" {...stroke}>
      <path d="M2 20l28-10-4 18-9-5-4 6-2-8-9-1z" />
    </svg>
  );
  if (name === "wifi") return (
    <svg viewBox="0 0 32 32" width="30" height="30" {...stroke}>
      <path d="M3 12c8-8 18-8 26 0" />
      <path d="M7 17c5-5 13-5 18 0" />
      <path d="M11 22c3-3 7-3 10 0" />
      <circle cx="16" cy="26" r="1.5" fill="currentColor" />
    </svg>
  );
  if (name === "dumbbell") return (
    <svg viewBox="0 0 32 32" width="30" height="30" {...stroke}>
      <rect x="3" y="12" width="4" height="8" />
      <rect x="25" y="12" width="4" height="8" />
      <rect x="7" y="14" width="4" height="4" />
      <rect x="21" y="14" width="4" height="4" />
      <path d="M11 16h10" />
    </svg>
  );
  if (name === "bed") return (
    <svg viewBox="0 0 32 32" width="30" height="30" {...stroke}>
      <path d="M3 22V10" />
      <path d="M3 22h26v-6a4 4 0 00-4-4H14v6H3" />
      <circle cx="9" cy="16" r="2" />
      <path d="M29 22v3M3 22v3" />
    </svg>
  );
  if (name === "wave") return (
    <svg viewBox="0 0 32 32" width="22" height="22" {...stroke}>
      <path d="M2 13c3-4 6-4 9 0s6 4 9 0 6-4 9 0" />
      <path d="M2 21c3-4 6-4 9 0s6 4 9 0 6-4 9 0" />
    </svg>
  );
  if (name === "lotus") return (
    <svg viewBox="0 0 32 32" width="22" height="22" {...stroke}>
      <path d="M16 29c-6 0-10-4-10-9 4 0 8 2 10 6 2-4 6-6 10-6 0 5-4 9-10 9z" />
      <path d="M16 20V9" />
      <path d="M16 9c-3-3-3-6-3-6s4 1 5 4" />
      <path d="M16 9c3-3 3-6 3-6s-4 1-5 4" />
    </svg>
  );
  if (name === "tv") return (
    <svg viewBox="0 0 32 32" width="20" height="20" {...stroke}>
      <rect x="3" y="6" width="26" height="17" rx="1.5" />
      <path d="M12 27h8M16 23v4" />
    </svg>
  );
  if (name === "housekeeping") return (
    <svg viewBox="0 0 32 32" width="20" height="20" {...stroke}>
      <path d="M16 3l2.5 7.5L26 13l-7.5 2.5L16 23l-2.5-7.5L6 13l7.5-2.5L16 3z" />
    </svg>
  );
  if (name === "robe") return (
    <svg viewBox="0 0 32 32" width="20" height="20" {...stroke}>
      <path d="M16 5a3 3 0 013 3c0 1.2-1.3 2-3 2s-3-.8-3-2a3 3 0 013-3z" />
      <path d="M16 10L4 21h9l3-4 3 4h9L16 10z" />
    </svg>
  );
  if (name === "coffee") return (
    <svg viewBox="0 0 32 32" width="20" height="20" {...stroke}>
      <path d="M6 12h16v8a6 6 0 01-6 6h-4a6 6 0 01-6-6v-8z" />
      <path d="M22 14h2a3 3 0 010 6h-2" />
      <path d="M11 4c0 2-2 2-2 4M18 4c0 2-2 2-2 4" />
    </svg>
  );
  if (name === "safe") return (
    <svg viewBox="0 0 32 32" width="20" height="20" {...stroke}>
      <rect x="5" y="5" width="22" height="22" rx="2" />
      <circle cx="16" cy="16" r="5" />
      <path d="M16 16v-3.5" />
      <path d="M22 10.5h2.5" />
    </svg>
  );
  if (name === "desk") return (
    <svg viewBox="0 0 32 32" width="20" height="20" {...stroke}>
      <path d="M3 13h26" />
      <path d="M5 13v13M27 13v13" />
      <path d="M3 19h6" />
      <path d="M19 4l4 4-8 8-4 1 1-4 7-9z" />
    </svg>
  );
  if (name === "climate") return (
    <svg viewBox="0 0 32 32" width="20" height="20" {...stroke}>
      <circle cx="16" cy="16" r="11" />
      <path d="M16 9v7l5 3" />
    </svg>
  );
  if (name === "hairdryer") return (
    <svg viewBox="0 0 32 32" width="20" height="20" {...stroke}>
      <path d="M6 13a7 7 0 017-7h5a3 3 0 013 3v8a3 3 0 01-3 3h-2" />
      <path d="M23 12h4" />
      <path d="M11 17l-4 10" />
      <path d="M26 9c2 1 2 4 0 5" />
    </svg>
  );
  if (name === "minibar") return (
    <svg viewBox="0 0 32 32" width="20" height="20" {...stroke}>
      <rect x="8" y="3" width="16" height="26" rx="2" />
      <path d="M8 13h16" />
      <circle cx="19" cy="8" r="0.8" fill="currentColor" />
      <circle cx="19" cy="18" r="0.8" fill="currentColor" />
    </svg>
  );
  if (name === "shower") return (
    <svg viewBox="0 0 32 32" width="20" height="20" {...stroke}>
      <path d="M6 13a10 10 0 0120 0" />
      <path d="M16 13v-6" />
      <path d="M10 18v2M16 19v3M22 18v2" />
    </svg>
  );
  if (name === "balcony") return (
    <svg viewBox="0 0 32 32" width="20" height="20" {...stroke}>
      <path d="M5 4v24M27 4v24" />
      <path d="M5 13h22" />
      <path d="M9 13v15M14 13v15M18 13v15M23 13v15" />
    </svg>
  );
  if (name === "layout") return (
    <svg viewBox="0 0 32 32" width="20" height="20" {...stroke}>
      <rect x="3" y="7" width="11" height="18" rx="1" />
      <rect x="18" y="7" width="11" height="18" rx="1" />
      <path d="M14 16h4" />
    </svg>
  );
  if (name === "sofa") return (
    <svg viewBox="0 0 32 32" width="22" height="22" {...stroke}>
      <path d="M6 16v8h20v-8" />
      <path d="M4 14a3 3 0 013-3h2a3 3 0 013 3v4H4v-4z" />
      <path d="M20 14a3 3 0 013-3h2a3 3 0 013 3v4H20v-4z" />
      <path d="M9 11V9a2 2 0 012-2h10a2 2 0 012 2v2" />
      <path d="M6 24v3M26 24v3" />
    </svg>
  );
  return null;
};
